import { ORDER_NAME_MAP } from '@entities/clients';
import { ActiveSort, CallsSortDirection } from './types';

const CLIENT_SORT_COLUMNS = new Set(['calls']);

export const splitActiveSorts = (activeSorts?: ActiveSort[]) => {
  const callsSortDirection: CallsSortDirection =
    activeSorts?.find((activeSort) => activeSort.column === 'calls')?.direction ?? null;

  const serverSorts = activeSorts?.filter((activeSort) => !CLIENT_SORT_COLUMNS.has(activeSort.column)) ?? [];

  return { callsSortDirection, serverSorts };
};

export const mapServerSortsToOrderBy = (serverSorts: ActiveSort[]) =>
  serverSorts.map(({ column, direction }) => `${ORDER_NAME_MAP[column]}_${direction}`.toUpperCase());
